import React, {Component} from "react";
import {Box, Button, IconButton, ImageList, ImageListItem, ImageListItemBar, Stack} from "@mui/material";
import {AddRounded, DeleteRounded, DownloadTwoTone} from "@mui/icons-material";
import {morphleBaseTheme1} from "../themes";
import {getStateAwareUrl, isNull} from "../../../utils/utils";
import {Loading} from "../components/components";

class FileScreenshotsList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            hovered: null,
        }
    }

    download = (url) => {
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = url.split('/').pop();
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    };

    render() {
        if(isNull(this.props.files))
            return <Loading/>
        return <Box minHeight={80} height={"100%"} overflow={"auto"}>
            <ImageList cols={this.props.cols}>
                {this.props.files.map(file => {
                    const absolute_file_url = window.location.origin + getStateAwareUrl('') + file.url_safe
                    return (<ImageListItem key={file.id + Math.random()}
                                           onMouseEnter={() => this.props.showOnHover && this.setState({hovered: file})}
                                           onMouseLeave={() => this.props.showOnHover && this.setState({hovered: null})}
                                           className={this.props.selected === file.id ? "scrollIntoView" : ""}
                                           style={{width: "125px", height: "80px"}}
                                           sx={this.props.selected === file.id ? {border: `3px solid ${morphleBaseTheme1.palette.secondary.main}`} : {border: `3px solid rgba(0,0,0,0.0)`}}>
                        <img
                            src={`${absolute_file_url}?w=120&h=100&fit=crop&auto=format`}
                            srcSet={`${absolute_file_url}?w=120&h=100&fit=crop&auto=format&dpr=2 2x`}
                            alt={file.id}
                            onClick={() => this.props.onClick(file)}
                            style={{cursor: 'pointer'}}
                            loading="lazy"
                        />
                        {(!this.props.showOnHover || (this.props.showOnHover && this.state.hovered === file)) &&
                            <ImageListItemBar key={file.id}
                                              title={this.props.title && this.props.title(file)}
                                              sx={this.props.backgroundColor && {backgroundColor: this.props.backgroundColor}}
                                              position={this.props.itemBarPosition}
                                              actionIcon={<Stack direction={"row"}>
                                                  {this.props.customAction && this.props.customAction(file)}
                                                  <IconButton onClick={() => this.download(absolute_file_url)}>
                                                      <DownloadTwoTone sx={{fontSize: 15}}/>
                                                  </IconButton>
                                                  {this.props.onDelete && !this.props.disabled &&
                                                      <IconButton onClick={() => this.props.onDelete(file)}>
                                                          <DeleteRounded sx={{fontSize: 15}}/>
                                                      </IconButton>}
                                              </Stack>}/>}
                    </ImageListItem>)
                })}
                {this.props.onAdd && <ImageListItem key={"add case image"}>
                    <Button onClick={this.props.onAdd} color={"secondary"}
                            sx={{width: 125, height: 80, border: 1}}>
                        <AddRounded/>
                    </Button>
                </ImageListItem>}
            </ImageList>
        </Box>
    }
}

export default FileScreenshotsList;
